export const GET_CHATROOM_DETAIL = '[Chatroom] Get Chatroom Detail';
export const GET_CHATROOM_DETAIL_SUCCESS = '[Chatroom] Get Chatroom Detail Success';
export const GET_CHATROOM_DETAIL_FAILURE = '[Chatroom] Get Chatroom Detail Failure';